import React from 'react';

const ToggleArrowIcon: React.FC = () => {
  return (
    <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 12L0 6L6 0L7.4 1.4L2.825 6L7.4 10.6L6 12ZM12.6 12L6.6 6L12.6 0L14 1.4L9.425 6L14 10.6L12.6 12Z"
        fill="#6E6E6E"
      />
    </svg>
  );
};

export default ToggleArrowIcon;
